import React, { useEffect, useState } from "react";
import PagesIndex from "../../../PagesIndex";
import Index from "../../../Index";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import moment from "moment";
import EditSubscriptionPackage from "./EditSubscriptionPackage";
import {
  activeDeactiveSubscriptionPackage,
  getSubscriptionPackageListAction,
} from "../../../../redux/admin/action";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 750,
  bgcolor: "background.paper",
  boxShadow: 24,
  padding: 2,
  borderRadius: 1,
};

const SubscriptionPackageList = () => {
  const navigate = PagesIndex.useNavigate();
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(false);
  const [masterWarden, setMasterWarden] = useState([]);
  const [updatePackage, setUpdatePackage] = useState({});
  const [pageData, setPageData] = useState([]);
  const [search, setSearch] = useState("");
  const [filterData, setFilteredData] = useState([]);
  const { adminToken } = PagesIndex.useSelector((state) => state.AdminReducer);

  const handleSearch = async (e) => {
    setSearch(e.target.value.trim());
  };

  const handelClose = () => {
    setOpen(false);
  };

  const handleAddMasterWarden = () => {
    setOpen(true);
  };

  const getPackageList = () => {
    getSubscriptionPackageListAction(adminToken, navigate).then((res) => {
      setMasterWarden(res);
      setLoading(false);
    });
  };

  useEffect(() => {
    getPackageList();
  }, []);

  useEffect(() => {
    const filtered = masterWarden?.filter((item) => {
      const searchLower = search?.toLowerCase();
      const createdAtFormatted = moment(item?.createdAt)?.format("DD/MM/YYYY");

      return (
        !search ||
        item?.packageName?.toLowerCase()?.includes(searchLower) ||
        String(item?.USDValue)?.includes(search) ||
        item?.SAPToken?.toLowerCase()?.includes(searchLower) ||
        item?.appleProviderId?.toLowerCase()?.includes(searchLower) ||
        item?.googleProviderId?.toLowerCase()?.includes(searchLower) ||
        item?.packageDescription?.toLowerCase()?.includes(searchLower) ||
        createdAtFormatted?.includes(searchLower)
      );
    });

    setFilteredData(filtered || []);
  }, [masterWarden, search]);

  const copyToClipboard = async (address) => {
    try {
      await navigator.clipboard.writeText(address);
      Index.toast.success("Copied successfully");
    } catch (err) {
      Index.toast.error("Could not copy address");
    }
  };

  const handleSwitchChange = (event, id) => {
    setLoading(true);
    activeDeactiveSubscriptionPackage({ id }, adminToken).then((res) => {
      if (res?.status === 200) {
        Index.toast.success(res?.message);
        getPackageList();
      }
    });
  };

  return (
    <>
      <Index.Box className="page-content-box">
        <Index.Box className="episap-common-box">
          <Index.Box className="title-header">
            <Index.Box className="title-header-flex res-title-header-flex">
              <Index.Box className="title-main">
                <Index.Typography
                  variant="p"
                  component="p"
                  className="page-title"
                >
                  Subscription Package
                </Index.Typography>
              </Index.Box>
              <Index.Box className="d-flex align-items-center res-set-search">
                <PagesIndex.Search className="searchbar">
                  <PagesIndex.StyledInputBase
                    placeholder="Search"
                    inputProps={{ "aria-label": "search" }}
                    onChange={handleSearch}
                  />
                </PagesIndex.Search>
              </Index.Box>
            </Index.Box>
          </Index.Box>

          <Index.Box className="table-box table_scroll">
            <Index.TableContainer
              component={Index.Paper}
              className="episap-table-container"
            >
              <Index.Table
                stickyHeader
                aria-label="sticky table"
                className="episap-table-main user-list-table"
              >
                <Index.TableHead className="table-head">
                  <Index.TableRow>
                    <Index.TableCell align="left">No </Index.TableCell>
                    <Index.TableCell align="left">
                      Package Name{" "}
                    </Index.TableCell>
                    <Index.TableCell align="left">
                      Package Description{" "}
                    </Index.TableCell>
                    <Index.TableCell align="left">SAP Token </Index.TableCell>
                    <Index.TableCell align="left">Matic Token </Index.TableCell>
                    <Index.TableCell align="left">USD Value</Index.TableCell>
                    <Index.TableCell align="left">
                      Google Product Id
                    </Index.TableCell>
                    <Index.TableCell align="left">
                      Apple Product Id
                    </Index.TableCell>
                    <Index.TableCell align="left">
                      Created Date & Time
                    </Index.TableCell>
                    <Index.TableCell align="center">Action</Index.TableCell>
                  </Index.TableRow>
                </Index.TableHead>
                <Index.TableBody className="table-body">
                  {!loading ? (
                    pageData.length ? (
                      pageData.map((row) => {
                        return (
                          <Index.TableRow key={row?.sNo}>
                            <Index.TableCell align="left">
                              {row?.sNo}
                            </Index.TableCell>
                            <Index.TableCell align="left">
                              {row?.packageName || "-"}
                            </Index.TableCell>
                            <Index.TableCell align="left">
                              {row?.packageDescription || "-"}
                            </Index.TableCell>
                            {/* <Index.TableCell align="left">
                              <Index.Box className="wallet-address">
                                <Index.Tooltip title={`${row?.SAPToken}`}>
                                  {row?.SAPToken
                                    ? `${row?.SAPToken?.substring(
                                        0,
                                        4
                                      )}.....${row?.SAPToken?.substring(
                                        row?.SAPToken?.length - 4
                                      )}`
                                    : "-"}
                                </Index.Tooltip>
                                {row?.SAPToken && (
                                  <Index.Box style={{ cursor: "pointer" }}>
                                    <ContentCopyIcon
                                      fontSize="small"
                                      onClick={() =>
                                        copyToClipboard(row?.SAPToken)
                                      }
                                    />
                                  </Index.Box>
                                )}
                              </Index.Box>
                            </Index.TableCell> */}
                            <Index.TableCell align="left">
                              {row?.SAPToken || "-"}
                            </Index.TableCell>
                            <Index.TableCell align="left">
                              {row?.maticToken || "-"}
                            </Index.TableCell>
                            <Index.TableCell align="left">
                              {row?.USDValue || "-"}
                            </Index.TableCell>
                            <Index.TableCell align="left">
                              {row?.googleProviderId || "-"}
                            </Index.TableCell>
                            <Index.TableCell align="left">
                              {row?.appleProviderId || "-"}
                            </Index.TableCell>
                            <Index.TableCell align="left">
                              {moment(row?.createdAt).format(
                                "DD/MM/YYYY hh:mm A"
                              ) || "-"}
                            </Index.TableCell>
                            <Index.TableCell className="action-btn-icon">
                              <Index.Box sx={{ display: "flex" }}>
                                <Index.Tooltip
                                  title={`${
                                    row?.isActive ? "Deactive" : "Active"
                                  }`}
                                >
                                  <Index.Switch
                                    className="toggel-switch"
                                    size="small"
                                    {...PagesIndex.label}
                                    checked={row?.isActive ? true : false}
                                    onChange={(event) => {
                                      handleSwitchChange(event, row?._id);
                                    }}
                                  />
                                </Index.Tooltip>
                                <Index.Tooltip title="Edit">
                                  <Index.Button
                                    className="icon-btns"
                                    onClick={() => {
                                      setUpdatePackage(row);
                                      handleAddMasterWarden();
                                    }}
                                  >
                                    <Index.EditIcon />
                                  </Index.Button>
                                </Index.Tooltip>
                              </Index.Box>
                            </Index.TableCell>
                          </Index.TableRow>
                        );
                      })
                    ) : (
                      <PagesIndex.NoRecordFound colSpan={12} />
                    )
                  ) : (
                    <PagesIndex.PageLoading colSpan={12} />
                  )}
                </Index.TableBody>
              </Index.Table>
            </Index.TableContainer>
          </Index.Box>
          <Index.Box className="pagination-design flex-end">
            <Index.Stack spacing={2}>
              <PagesIndex.Pagination
                fetchData={filterData}
                setPageData={setPageData}
                pageData={pageData}
              />
            </Index.Stack>
          </Index.Box>
        </Index.Box>
      </Index.Box>

      {/* Add Edit Master Warden Popup */}
      <Index.Modal
        open={open}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="auth-modal login-with-modal"
      >
        <Index.Box
          sx={style}
          className="auth-modal-inner-main login-with-modal-inner-main"
        >
          <EditSubscriptionPackage
            handelClose={handelClose}
            getPackageList={getPackageList}
            updatePackage={updatePackage}
          />
        </Index.Box>
      </Index.Modal>
    </>
  );
};

export default SubscriptionPackageList;
